<template>
  <div class="analyze-target-user-list">
    <b-row class="title-bar">
      <h1>
        <span class="user-count" v-bind:class="{ error: state === false }">
          {{ userCount }}
        </span>
        {{ $tc('appAnalyzeTargetUserList.userCount', userCount) }}
      </h1>
      <span v-if="state === false" class="error caption">
        {{ $tc('appAnalyzeTargetUserList.message.usersOver', maxUsersCount) }}
      </span>
    </b-row>
    <b-row no-gutters class="list-container">
      <ul class="list">
        <li
          v-for="user in usersForDisplay"
          v-bind:key="`${user.type}_${user.id}`"
          class="list-item"
        >
          <span class="user-name">{{ user.name }}</span>
          <text-clear class="clear-button" v-on:click="$_onClearClick(user)" />
        </li>
      </ul>
    </b-row>
  </div>
</template>

<script>
import textClear from '@/assets/ifield/text-clear.svg?component'

export default {
  name: 'AppAnalyzeTargetUserList',
  components: {
    'text-clear': textClear,
  },
  props: {
    /**
     * ユーザー
     */
    users: {
      type: Array,
      default: null,
    },
    /**
     * バリデーション状態
     */
    state: {
      type: Boolean,
      default: null,
    },
    /**
     * 最大ユーザー数(表示用)
     */
    maxUsersCount: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    /**
     * ユーザー数
     * @type {Number}
     */
    userCount: function () {
      if (!this.users) return 0
      const userList = this.users.flatMap((item) => {
        return item.users || [item]
      })
      const uniqueUserList = new Set(
        userList.filter((user) => user && user.id).map((user) => user.id)
      )
      return uniqueUserList.size
    },
    /**
     * 表示用ユーザー選択値
     * @type {Object[]}
     */
    usersForDisplay: function () {
      if (!this.users) return []
      return this.users.map((u) => ({
        ...u,
        name:
          u.type === 'organization' ? `${u.name} (${u.users.length})` : u.name,
      }))
    },
  },
  methods: {
    /**
     * ユーザー選択解除イベント発行
     * @param {Object} item 取り除くアイテム
     */
    $_onClearClick: function (item) {
      const users = this.users.filter(
        (u) => u.type !== item.type || u.id !== item.id
      )
      /**
       * ユーザー選択変更イベント
       * @param {Array.<Object>} users 選択されたユーザー
       */
      this.$emit('users-changed', users)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../assets/scss/parts/title-bar';

$-item-height: 32px;

.list-container {
  height: calc(100% - #{$title-bar-height});
}

.title-bar {
  border-bottom: 2px solid #eaecef;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  column-gap: 16px;
}

.user-count {
  margin-right: -2px;
}

.error {
  color: $text-color-error;
  font-size: $font-size-middle;
}

.caption {
  line-height: 1;
}

.list {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  @include mixin-scrollbar;
}

.list-item {
  width: 100%;
  min-height: $-item-height;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 0 32px;
  border-bottom: 1px solid #eaecef;
}

.user-name {
  font-size: 0.875rem;
  color: #333333;
  line-height: 1.5;
  text-align: left;
  padding: 4px 0;
}

.clear-button {
  flex-shrink: 0;
  height: 28px;
  width: 28px;
  fill: #cfcfcf;
  padding: 2px;
  cursor: pointer;

  &:hover {
    background: #eaecef;
    border-radius: 50%;
    fill: #333333;
  }
}
</style>
